/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSlackUserVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateSlackUserVerificationKeyMutationVariables = {
    input: CreateSlackUserVerificationKeyInput;
};
export type CreateSlackUserVerificationKeyMutationResponse = {
    readonly createSlackUserVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type CreateSlackUserVerificationKeyMutation = {
    readonly response: CreateSlackUserVerificationKeyMutationResponse;
    readonly variables: CreateSlackUserVerificationKeyMutationVariables;
};



/*
mutation CreateSlackUserVerificationKeyMutation(
  $input: CreateSlackUserVerificationKeyInput!
) {
  createSlackUserVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSlackUserVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSlackUserVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createSlackUserVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSlackUserVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSlackUserVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSlackUserVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSlackUserVerificationKeyMutation(\n  $input: CreateSlackUserVerificationKeyInput!\n) {\n  createSlackUserVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '79fbb6831e204c00aa13ba4a6010a93a';
export default node;
